<template>
  <v-navigation-drawer
    v-model="isOpen"
    :width="$isMobile ? '100%' : '50%'"
    right
    fixed
    :permanent="isOpen"
    hide-overlay
    class="z-index--100">
    <div class="ma-3">
      <div class="d-flex">
        <v-btn
          dark
          fab
          x-small
          outlined
          color="primary"
          class="mr-3"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="subtitle-1 primary--text">
          Información de {{ item.name }}
        </div>
      </div>
      <div>
        <div
          v-if="loading"
          class="d-flex justify-center align-center">
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <div
          v-else>
          <div
            v-if="data.recipes && data.recipes.length"
            class="mb-4">
            <div
              class="py-3 primary--text font-weight-bold">
              Uso en recetas:
            </div>
            <v-card>
              <v-data-table
                :items="data.recipes"
                :headers="[
                  { text: this.$i18n.t('recipes.headers.name'), value: 'name', sortable: true },
                  { text: this.$i18n.t('recipes.headers.quantity'), value: 'ingredient', sortable: false }
                ]"
                dense
                hide-default-footer>
                <template v-slot:item.ingredient="{ item }">
                  <span class="caption grey--text align-right">
                    {{ item.ingredient ? item.ingredient.unit.name : '' }}
                  </span>
                  <span class="align-right">
                    {{ item.ingredient ? (item.ingredient.quantity).toFixed(2) : '' }}
                  </span>
                </template>
              </v-data-table>
            </v-card>
          </div>
          <div
            v-if="data.movements && data.movements.length"
            class="mb-4">
            <div class="py-3 primary--text font-weight-bold">
              Movimientos de inventario:
            </div>
            <v-card>
              <v-data-table
                :items="data.movements"
                :headers="[
                  { text: 'Fecha', value: 'createdAt', sortable: true },
                  { text: 'Última cantidad registrada', value: 'quantity', sortable: false },
                  { text: 'Cantidad previa', value: 'previousValue', sortable: false }
                ]"
                dense
                hide-default-footer>
                <template v-slot:item.createdAt="{ item }">
                  {{ convertToDateString(item.createdAt) }}
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      loading: false,
      item: {},
      data: {}
    }
  },
  watch: {
    async isOpen (val) {
      if (val) {
        await this.load()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open (item) {
      this.isOpen = true
      this.item = item
    },
    close () {
      this.isOpen = false
    },
    async load () {
      this.loading = true
      try {
        const data = await this.$api.get('/v1/inputs/info', { product: this.item.product.id, area: this.area })
        this.data = data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    }
  }
}
</script>
